PegasusTemplate.LoadingView = Ember.View.extend({
  isVisible: false,
  didInsertElement: function(){
    this._super();
    Em.run.scheduleOnce('afterRender', this.get('controller'), 'send', 'doneLoading');
  }
});
